import React, { Component } from "react";
import Axios from "axios";
import { getUser } from "../../actions/session";
import {
  LOGIN_URL,
  ALL_ACCOUNT_LIST,
  TABLE_STATS,
  SERVER_PATH,
} from "../../config/rest_endpoints";
import CustomLoader from "../common/loader";
import ReactTooltip from "react-tooltip";
import { Notifications } from "../common/notification";
import { Redirect, withRouter } from "react-router";
import MultiSelect from "@khanacademy/react-multi-select";
import { ACCOUNTS_PER_DAY } from "../routers/RouteConstants";
import { Link } from "react-router-dom";

// datetime picker imports
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import { fmtDollar4, fmtMins, fmtInt } from '../common/formatters';

class ChangeAccountStats extends Component {
  constructor(props) {
    super(props);
    // initializing states
    this.state = {
      User: getUser(),
      data: [],
      startDate: moment(),
      endDate: moment(),
      quickDatePreset: "today",
      isGetting: false,
      isGettingReport: false,
      isLoginURL: false,
      accountList: [],
      selectedAccount: [],
      isBtnSpin: false,
      isDownLoadSpin: false,
      expandedRows: {},
      accountReport: [],
      sortColumn: null,
      sortDirection: "asc",
      excludeNoActivity: true,
    };
    this.getReportOnSelectDate = this.getReportOnSelectDate.bind(this);
    this.handleDate = this.handleDate.bind(this);
    this.handleQuickDateSelect = this.handleQuickDateSelect.bind(this);
    this.handleSelectAccount = this.handleSelectAccount.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleExcludeNoActivity = this.handleExcludeNoActivity.bind(this);
  }

  componentDidMount() {
    this.getReportOnSelectDate();
    this.getAllCarrierNames();
    this.setState({ isBtnSpin: false, isDownLoadSpin: false });
  }

  handleSelectAccount(selectedAccount) {
    this.setState({ selectedAccount });
  }

  // handle date and time on selection of datetime picker
  handleDate(date, value) {
    if (value == "start") {
      this.setState({ startDate: date, quickDatePreset: "" }, () => {
        console.log("start", this.state.startDate);
      });
    } else {
      this.setState({ endDate: date, quickDatePreset: "" }, () => {
        console.log("end", this.state.endDate);
      });
    }
  }

  handleQuickDateSelect(preset) {
    let startDate, endDate;
    switch (preset) {
      case "today":
        startDate = moment().utc().startOf("day");
        endDate = moment().utc();
        break;
      case "yesterday":
        startDate = moment().utc().subtract(1, "day").startOf("day");
        endDate = moment().utc().subtract(1, "day").endOf("day");
        break;
      case "thisWeek":
        startDate = moment().utc().startOf("isoWeek");
        endDate = moment().utc();
        break;
      case "thisMonth":
        startDate = moment().utc().startOf("month");
        endDate = moment().utc();
        break;
      default:
        return;
    }
    this.setState({ startDate, endDate, quickDatePreset: preset });
  }

  onRedirecting(data) {
    console.log("data", data);
    var id = data.accountID;
    var Name = data.accountName;
    this.setState({ name: Name });
    if (id !== "" && Name !== "") {
      this.props.history.push(`${ACCOUNTS_PER_DAY}/${id}/${Name}`);
    } else {
      Notifications.notify("Id or name not found", "Cannot Redirect", "error");
    }
  }

  toggleRow(rowId) {
    const { User, startDate, endDate, expandedRows } = this.state;
    let StDate = moment(startDate).format("MM/DD/YYYY, h:mm:ss A");
    let enDate = moment(endDate).format("MM/DD/YYYY, h:mm:ss A");
    const isExpanded = expandedRows[rowId];

    const selectedRow = this.state.data[rowId];

    const newExpandedRows = {};
    for (let key in expandedRows) {
      newExpandedRows[key] = false;
    }

    if (!isExpanded) {
      // If the row is not expanded
      const accountId = selectedRow.accountID;
      const url = `${SERVER_PATH}/apiv1/reporting/carrier/stats/account/${accountId}`;
      const payload = {
        startDate: StDate,
        endDate: enDate,
        accountId: accountId,
      };
      this.setState({ isGettingReport: true });
      const headers = { Authorization: "Bearer " + User.token };
      Axios.post(url, payload, { headers })
        .then((res) => {
          console.log("POST request successful:", res.data);
          if (res) {
            var resp = res.data.data || [];
            this.setState({
              accountReport: resp,
              expandedRows: {
                ...newExpandedRows,
                [rowId]: true,
              },
              isGettingReport: false,
            });
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });
      this.setState({
        expandedRows: {
          ...newExpandedRows,
          [rowId]: true,
        },
        isGettingReport: true,
      });
    } else {
      // If the row is expanded, simply collapse it
      this.setState({
        expandedRows: newExpandedRows,
        isGettingReport: false,
      });
    }
  }

  getAllCarrierNames() {
    const { User } = this.state;

    var headers = { Authorization: "Bearer " + User.token };
    Axios.get(ALL_ACCOUNT_LIST, { headers })
      .then((res) => {
        if (res) {
          var resp = res.data.data;
          console.log(`resp`, resp);
          const list = resp.map((row) => {
            row["label"] = row["accountName"];
            row["value"] = row["id"];
            return row;
          });
          this.setState({ accountList: list }, () => {});
        }
      })
      .catch((err) => {
        const alert = err.response;
        console.log(`alert.data.message`, alert.data.message);
        if (alert.data.message === "invalid or expired jwt") {
          localStorage.removeItem("user");
          this.setState({ isLoginURL: true });
          Notifications.notify(alert.data.message, "Token Expire", "error");
        }
        Notifications.notify(alert.data.message, "Failed", "error");
        this.setState({
          isGetting: false,
        });
      });
  }

  handleExcludeNoActivity(e) {
    this.setState({ excludeNoActivity: e.target.checked });
  }

  // on filter we are Account stats
  getReportOnSelectDate(data) {
    const { User, startDate, endDate, selectedAccount, excludeNoActivity } =
      this.state;
    var payload = {
      startDate: moment(startDate).format("MM/DD/YYYY, h:mm:ss A"),
      endDate: moment(endDate).format("MM/DD/YYYY, h:mm:ss A"),
      accounts: selectedAccount,
      excludeOnesWithNoActivity: excludeNoActivity,
    };
    console.log("payload", payload);
    console.log("startDate", payload.startDate);
    console.log("endDate", payload.endDate);
    this.setState({ isGetting: true, isBtnSpin: true, isDownLoadSpin: false });
    var headers = { Authorization: "Bearer " + User.token };
    if (data === "download") {
      this.setState({
        isGetting: false,
        isBtnSpin: false,
        isDownLoadSpin: true,
      });
      Axios.post(`${TABLE_STATS}?download=true`, payload, { headers })
        .then((res) => {
          if (res) {
            var resp = res.data;
            const getFileName = res.headers["content-disposition"];
            const settingFileName = getFileName.replace(
              "attachment; filename=",
              ""
            );
            const url = window.URL.createObjectURL(new Blob([resp]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${settingFileName}.csv`);
            document.body.appendChild(link);
            Notifications.notify(
              "File is been downloading...",
              "Downloading",
              "success"
            );
            link.click();
            this.setState({
              isGetting: false,
              isBtnSpin: false,
              isDownLoadSpin: false,
            });
          }
        })
        .catch((err) => {
          const alert = err.response;
          console.log(`alert.data.message`, alert.data.message);
          if (alert.data.message === "invalid or expired jwt") {
            localStorage.removeItem("user");
            this.setState({ isLoginURL: true });
            Notifications.notify(alert.data.message, "Token Expire", "error");
          }
          Notifications.notify(alert.data.message, "Failed", "error");
          this.setState({
            isGetting: false,
            isBtnSpin: false,
          });
        });
    } else {
      Axios.post(`${TABLE_STATS}`, payload, { headers })
        .then((res) => {
          if (res) {
            var resp = res.data.data;
            console.log(resp);
            this.setState({
              data: resp,
              isGetting: false,
              isBtnSpin: false,
            });
          }
        })
        .catch((err) => {
          const alert = err.response;
          console.log(`alert.data.message`, alert.data.message);
          if (alert.data.message === "invalid or expired jwt") {
            localStorage.removeItem("user");
            this.setState({ isLoginURL: true });
            Notifications.notify(alert.data.message, "Token Expire", "error");
          }
          Notifications.notify(alert.data.message, "Failed", "error");
          this.setState({
            isGetting: false,
          });
        });
    }
  }

  handleSort(column) {
    const { sortColumn, sortDirection, data } = this.state;
    let newDirection = "asc";

    if (sortColumn === column) {
      newDirection = sortDirection === "asc" ? "desc" : "asc";
    }

    const sortedData = [...data].sort((a, b) => {
      let aValue = a[column];
      let bValue = b[column];

      // Handle percentage values
      if (column.startsWith("attempts_")) {
        aValue =
          aValue === "N/A" || !aValue
            ? 0
            : typeof aValue === "string"
            ? parseFloat(aValue.replace("%", ""))
            : parseFloat(aValue);
        bValue =
          bValue === "N/A" || !bValue
            ? 0
            : typeof bValue === "string"
            ? parseFloat(bValue.replace("%", ""))
            : parseFloat(bValue);
      }
      // Handle numeric values
      else if (typeof aValue === "number" || !isNaN(parseFloat(aValue))) {
        aValue = parseFloat(aValue) || 0;
        bValue = parseFloat(bValue) || 0;
      }
      // Handle string values (like accountName)
      else {
        aValue = (aValue || "").toString().toLowerCase();
        bValue = (bValue || "").toString().toLowerCase();
      }

      if (newDirection === "asc") {
        return aValue > bValue ? 1 : -1;
      } else {
        return aValue < bValue ? 1 : -1;
      }
    });

    this.setState({
      data: sortedData,
      sortColumn: column,
      sortDirection: newDirection,
    });
  }

  getSortIcon(column) {
    const { sortColumn, sortDirection } = this.state;
    if (sortColumn !== column) {
      return (
        <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
          <i
            className="icon-arrow-up8"
            style={{ fontSize: "13px", color: "#ccc" }}
          ></i>
          <i
            className="icon-arrow-down8"
            style={{ fontSize: "13px", color: "#ccc" }}
          ></i>
        </div>
      );
    }
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
        <i
          className="icon-arrow-up8"
          style={{
            fontSize: "13px",
            fontWeight: 900,
            color: sortDirection === "asc" ? "#4caf50" : "#ccc",
          }}
        ></i>
        <i
          className="icon-arrow-down8"
          style={{
            fontSize: "13px",
            fontWeight: 900,
            color: sortDirection === "desc" ? "#4caf50" : "#ccc",
          }}
        ></i>
      </div>
    );
  }

  renderReportTable() {
    const { data, isGetting, expandedRows, accountReport, isGettingReport } =
      this.state;
    console.log("data", data);
    if (data.length === 0 || data === null) {
      return (
        <div className="ml-3 mt-3">
          <div
            className="dataTables_info"
            id="DataTables_Table_0_info"
            role="status"
            aria-live="polite"
          >
            Showing 0 of 0 entries
          </div>
          <div
            className="dataTables_paginate paging_simple_numbers"
            id="DataTables_Table_0_paginate"
          ></div>
        </div>
      );
    } else {
      return data.map((stats, idx) => {
        const isExpanded = expandedRows[idx];
        return (
          <>
            <tr key={idx} className="left_align">
              <td className="table-data">
                <i
                  className={`icon-plus3 ml-2 ${
                    isExpanded ? "icon-minus3" : ""
                  }`}
                  style={{ cursor: "pointer" }}
                  onClick={() => this.toggleRow(idx)}
                ></i>
              </td>

              <td
                className="table-data"
                onClick={this.onRedirecting.bind(this, stats)}
                // colSpan="1"
              >
                {" "}
                <Link>{stats.accountName}</Link>
              </td>
              <td className="table-data" style={{textAlign:'right'}}>
                <span className="text-success-600"></span> {fmtDollar4(stats["revenue"])}
              </td>
              <td className="table-data" style={{textAlign:'right'}}>
                <span className="text-success-600"></span> {fmtDollar4(stats["cost"])}
              </td>
              <td className="table-data" style={{textAlign:'right'}}>
                <span className="text-success-600"></span>
                {fmtDollar4(stats["profit"])}
              </td>
              <td className="table-data" style={{textAlign:'right'}}>
                <span className="text-success-600"></span>
                {fmtMins(stats["minutes"])}
              </td>
              <td className="table-data" style={{textAlign:'right'}}>
                <span className="text-success-600"></span>
                {stats["ACD"] !== undefined && stats["ACD"] !== "N/A" && !isNaN(stats["ACD"]) ? `${stats["ACD"]}%` : stats["ACD"]}
              </td>
              <td className="table-data" style={{textAlign:'right'}}>
                <span className="text-success-600"></span>
                {stats["SDP"] !== undefined && stats["SDP"] !== "N/A" && !isNaN(stats["SDP"]) ? `${stats["SDP"]}%` : stats["SDP"]}
              </td>
              <td className="table-data" style={{textAlign:'right'}}>
                <span className="text-success-600"></span>
                {stats["ASR"] !== undefined && stats["ASR"] !== "N/A" && !isNaN(stats["ASR"]) ? `${stats["ASR"]}%` : stats["ASR"]}
              </td>
              <td className="table-data" style={{textAlign:'right'}}>
                <span className="text-success-600"></span>
                {fmtInt(stats["completed"])}
              </td>
              <td className="table-data" style={{textAlign:'right'}}>
                <span className="text-success-600"></span>
                {fmtInt(stats["inCalls"])}
              </td>
              <td className="table-data" style={{textAlign:'right'}}>
                <span className="text-success-600"></span>
                {fmtInt(stats["outCalls"])}
              </td>

              <td className="table-data" style={{textAlign:'right'}}>
                <span className="text-success-600"></span>
                {fmtMins(stats["indeterminateMinutes"])}
              </td>
              <td className="table-data" style={{textAlign:'right'}}>
                <span className="text-success-600"></span>
                {fmtMins(stats["intrastateMinutes"])}
              </td>
              <td className="table-data" style={{textAlign:'right'}}>
                <span className="text-success-600"></span>
                {fmtMins(stats["interstateMinutes"])}
              </td>
              <td className="table-data" style={{textAlign:'right'}}>
                <span className="text-success-600"></span>
                {fmtInt(stats["sdCount"])}
              </td>
              <td className="table-data" style={{textAlign:'right'}}>
                <span className="text-success-600"></span>
                {stats["attempts_404"] !== undefined && stats["attempts_404"] !== "N/A" && !isNaN(stats["attempts_404"]) ? `${stats["attempts_404"]}%` : (stats["attempts_404"] || "N/A")}
              </td>
              <td className="table-data" style={{textAlign:'right'}}>
                <span className="text-success-600"></span>
                {stats["attempts_487"] !== undefined && stats["attempts_487"] !== "N/A" && !isNaN(stats["attempts_487"]) ? `${stats["attempts_487"]}%` : (stats["attempts_487"] || "N/A")}
              </td>
              <td className="table-data" style={{textAlign:'right'}}>
                <span className="text-success-600"></span>
                {stats["attempts_4xx"] !== undefined && stats["attempts_4xx"] !== "N/A" && !isNaN(stats["attempts_4xx"]) ? `${stats["attempts_4xx"]}%` : (stats["attempts_4xx"] || "N/A")}
              </td>
              <td className="table-data" style={{textAlign:'right'}}>
                <span className="text-success-600"></span>
                {stats["attempts_503"] !== undefined && stats["attempts_503"] !== "N/A" && !isNaN(stats["attempts_503"]) ? `${stats["attempts_503"]}%` : (stats["attempts_503"] || "N/A")}
              </td>
              <td className="table-data" style={{textAlign:'right'}}>
                <span className="text-success-600"></span>
                {stats["attempts_5xx"] !== undefined && stats["attempts_5xx"] !== "N/A" && !isNaN(stats["attempts_5xx"]) ? `${stats["attempts_5xx"]}%` : (stats["attempts_5xx"] || "N/A")}
              </td>
              <td className="table-data" style={{textAlign:'right'}}>
                <span className="text-success-600"></span>
                {stats["attempts_6xx"] !== undefined && stats["attempts_6xx"] !== "N/A" && !isNaN(stats["attempts_6xx"]) ? `${stats["attempts_6xx"]}%` : (stats["attempts_6xx"] || "N/A")}
              </td>
            </tr>
            {isExpanded && (
              <>
                {isGettingReport ? (
                  <tr>
                    <td colSpan="20" className="text-center">
                      <CustomLoader />
                    </td>
                  </tr>
                ) : (
                  <>
                    {accountReport.length === 0 || accountReport === null ? (
                      <tr>
                        <td
                          className="text-center"
                          style={{ backgroundColor: "#ffffff" }}
                          colSpan="20"
                        >
                          No data available
                        </td>
                      </tr>
                    ) : (
                      accountReport.map((stats, idx) => (
                        <tr key={idx} className="right_align">
                          <td className="table-data"></td>
                          <td className="table-data">
                            {stats.carrierName || "N/A"}
                          </td>
                          <td className="table-data" style={{textAlign:'right'}}>
                            <span className="text-success-600"></span>{" "}
                            {stats["revenue"] != null ? fmtDollar4(stats["revenue"]) : "N/A"}
                          </td>
                          <td className="table-data" style={{textAlign:'right'}}>
                            <span className="text-success-600"></span>{" "}
                            {stats["cost"] != null ? fmtDollar4(stats["cost"]) : "N/A"}
                          </td>
                          <td className="table-data" style={{textAlign:'right'}}>
                            <span className="text-success-600"></span>{" "}
                            {stats["profit"] != null ? fmtDollar4(stats["profit"]) : "N/A"}
                          </td>
                          <td className="table-data" style={{textAlign:'right'}}>
                            <span className="text-success-600"></span>{" "}
                            {stats["minutes"] != null ? fmtMins(stats["minutes"]) : "N/A"}
                          </td>
                          <td className="table-data" style={{textAlign:'right'}}>
                            <span className="text-success-600"></span>{" "}
                            {stats["ACD"] !== undefined && stats["ACD"] !== "N/A" && !isNaN(stats["ACD"]) ? `${stats["ACD"]}%` : (stats["ACD"] || "N/A")}
                          </td>
                          <td className="table-data" style={{textAlign:'right'}}>
                            <span className="text-success-600"></span>{" "}
                            {stats["SDP"] !== undefined && stats["SDP"] !== "N/A" && !isNaN(stats["SDP"]) ? `${stats["SDP"]}%` : (stats["SDP"] || "N/A")}
                          </td>
                          <td className="table-data" style={{textAlign:'right'}}>
                            <span className="text-success-600"></span>{" "}
                            {stats["ASR"] !== undefined && stats["ASR"] !== "N/A" && !isNaN(stats["ASR"]) ? `${stats["ASR"]}%` : (stats["ASR"] || "N/A")}
                          </td>
                          <td className="table-data" style={{textAlign:'right'}}>
                            <span className="text-success-600"></span>{" "}
                            {stats["completed"] != null ? fmtInt(stats["completed"]) : "N/A"}
                          </td>
                          <td className="table-data" style={{textAlign:'right'}}>
                            <span className="text-success-600"></span>{" "}
                            {stats["inCalls"] != null ? fmtInt(stats["inCalls"]) : "N/A"}
                          </td>
                          <td className="table-data" style={{textAlign:'right'}}>
                            <span className="text-success-600"></span>{" "}
                            {stats["outCalls"] != null ? fmtInt(stats["outCalls"]) : "N/A"}
                          </td>
                          <td className="table-data" style={{textAlign:'right'}}>
                            <span className="text-success-600"></span>{" "}
                            {stats["indeterminateMinutes"] != null ? fmtMins(stats["indeterminateMinutes"]) : "N/A"}
                          </td>
                          <td className="table-data" style={{textAlign:'right'}}>
                            <span className="text-success-600"></span>{" "}
                            {stats["intrastateMinutes"] != null ? fmtMins(stats["intrastateMinutes"]) : "N/A"}
                          </td>
                          <td className="table-data" style={{textAlign:'right'}}>
                            <span className="text-success-600"></span>{" "}
                            {stats["interstateMinutes"] != null ? fmtMins(stats["interstateMinutes"]) : "N/A"}
                          </td>
                          <td className="table-data" style={{textAlign:'right'}}>
                            <span className="text-success-600"></span>{" "}
                            {stats["sdCount"] != null ? fmtInt(stats["sdCount"]) : "N/A"}
                          </td>
                          <td className="table-data" style={{textAlign:'right'}}>
                            {stats["attempts_404"] !== undefined && stats["attempts_404"] !== "N/A" && !isNaN(stats["attempts_404"]) ? `${stats["attempts_404"]}%` : (stats["attempts_404"] || "N/A")}
                          </td>
                          <td className="table-data" style={{textAlign:'right'}}>
                            {stats["attempts_487"] !== undefined && stats["attempts_487"] !== "N/A" && !isNaN(stats["attempts_487"]) ? `${stats["attempts_487"]}%` : (stats["attempts_487"] || "N/A")}
                          </td>
                          <td className="table-data" style={{textAlign:'right'}}>
                            {stats["attempts_4xx"] !== undefined && stats["attempts_4xx"] !== "N/A" && !isNaN(stats["attempts_4xx"]) ? `${stats["attempts_4xx"]}%` : (stats["attempts_4xx"] || "N/A")}
                          </td>
                          <td className="table-data" style={{textAlign:'right'}}>
                            {stats["attempts_503"] !== undefined && stats["attempts_503"] !== "N/A" && !isNaN(stats["attempts_503"]) ? `${stats["attempts_503"]}%` : (stats["attempts_503"] || "N/A")}
                          </td>
                          <td className="table-data" style={{textAlign:'right'}}>
                            {stats["attempts_5xx"] !== undefined && stats["attempts_5xx"] !== "N/A" && !isNaN(stats["attempts_5xx"]) ? `${stats["attempts_5xx"]}%` : (stats["attempts_5xx"] || "N/A")}
                          </td>
                          <td className="table-data" style={{textAlign:'right'}}>
                            {stats["attempts_6xx"] !== undefined && stats["attempts_6xx"] !== "N/A" && !isNaN(stats["attempts_6xx"]) ? `${stats["attempts_6xx"]}%` : (stats["attempts_6xx"] || "N/A")}
                          </td>
                        </tr>
                      ))
                    )}
                  </>
                )}
              </>
            )}
          </>
        );
      });
    }
  }

  returnTotal() {
    const { data } = this.state;
    let totalRevenue = [];
    let totalCost = [];
    let totalProfit = [];
    let totalMinutes = [];
    let totalACD = [];
    let totalSDP = [];
    let totalASR = [];
    let totalCompleted = [];
    let totalInCalls = [];
    let totalOutCalls = [];
    let totalSDCount = [];
    let totalIndeterminateMinutes = [];
    let totalIntraMinutes = [];
    let totalInterMinutes = [];
    let totalAttempts404 = [];
    let totalAttempts487 = [];
    let totalAttempts4xx = [];
    let totalAttempts503 = [];
    let totalAttempts5xx = [];
    let totalAttempts6xx = [];

    if (data.length > 1) {
      console.log("=== Starting Total Calculation ===");
      console.log("Data length:", data.length);

      data.forEach((item, index) => {
        console.log(`\n--- Item ${index + 1}: ${item.accountName} ---`);
        console.log("Revenue:", item["revenue"]);
        console.log("Cost:", item["cost"]);
        console.log("Profit:", item["profit"]);
        console.log("Minutes:", item["minutes"]);
        console.log("ACD:", item["ACD"]);
        console.log("SDP:", item["SDP"]);
        console.log("ASR:", item["ASR"]);
        console.log("Completed:", item["completed"]);
        console.log("In Calls:", item["inCalls"]);
        console.log("Out Calls:", item["outCalls"]);
        console.log("SD Count:", item["sdCount"]);
        console.log("Indeterminate Minutes:", item["indeterminateMinutes"]);
        console.log("Intra Minutes:", item["intrastateMinutes"]);
        console.log("Inter Minutes:", item["interstateMinutes"]);
        console.log("Attempts 404:", item["attempts_404"]);
        console.log("Attempts 487:", item["attempts_487"]);
        console.log("Attempts 4xx:", item["attempts_4xx"]);
        console.log("Attempts 503:", item["attempts_503"]);
        console.log("Attempts 5xx:", item["attempts_5xx"]);
        console.log("Attempts 6xx:", item["attempts_6xx"]);

        totalRevenue.push(parseFloat(item["revenue"]) || 0);
        totalCost.push(parseFloat(item["cost"]) || 0);
        totalProfit.push(parseFloat(item["profit"]) || 0);
        totalMinutes.push(parseFloat(item["minutes"]) || 0);
        totalACD.push(item["ACD"]);
        totalSDP.push(item["SDP"]);
        totalASR.push(item["ASR"]);
        totalCompleted.push(parseFloat(item["completed"]) || 0);
        totalInCalls.push(parseFloat(item["inCalls"]) || 0);
        totalOutCalls.push(parseFloat(item["outCalls"]) || 0);
        totalSDCount.push(parseFloat(item["sdCount"]) || 0);
        totalIndeterminateMinutes.push(parseFloat(item["indeterminateMinutes"]) || 0);
        totalIntraMinutes.push(parseFloat(item["intrastateMinutes"]) || 0);
        totalInterMinutes.push(parseFloat(item["interstateMinutes"]) || 0);
        totalAttempts404.push(
          item["attempts_404"] === "N/A"
            ? 0
            : parseFloat(item["attempts_404"]) || 0
        );
        totalAttempts487.push(
          item["attempts_487"] === "N/A"
            ? 0
            : parseFloat(item["attempts_487"]) || 0
        );
        totalAttempts4xx.push(
          item["attempts_4xx"] === "N/A"
            ? 0
            : parseFloat(item["attempts_4xx"]) || 0
        );
        totalAttempts503.push(
          item["attempts_503"] === "N/A"
            ? 0
            : parseFloat(item["attempts_503"]) || 0
        );
        totalAttempts5xx.push(
          item["attempts_5xx"] === "N/A"
            ? 0
            : parseFloat(item["attempts_5xx"]) || 0
        );
        totalAttempts6xx.push(
          item["attempts_6xx"] === "N/A"
            ? 0
            : parseFloat(item["attempts_6xx"]) || 0
        );
      });

      console.log("\n=== Arrays of Values ===");
      console.log("Total Revenue Array:", totalRevenue);
      console.log("Total Cost Array:", totalCost);
      console.log("Total Profit Array:", totalProfit);
      console.log("Total Minutes Array:", totalMinutes);
      console.log("Total ACD Array:", totalACD);
      console.log("Total SDP Array:", totalSDP);
      console.log("Total ASR Array:", totalASR);
      console.log("Total Completed Array:", totalCompleted);
      console.log("Total In Calls Array:", totalInCalls);
      console.log("Total Out Calls Array:", totalOutCalls);
      console.log("Total SD Count Array:", totalSDCount);
      console.log(
        "Total Indeterminate Minutes Array:",
        totalIndeterminateMinutes
      );
      console.log("Total Intra Minutes Array:", totalIntraMinutes);
      console.log("Total Inter Minutes Array:", totalInterMinutes);
      console.log("Total Attempts 404 Array:", totalAttempts404);
      console.log("Total Attempts 487 Array:", totalAttempts487);
      console.log("Total Attempts 4xx Array:", totalAttempts4xx);
      console.log("Total Attempts 503 Array:", totalAttempts503);
      console.log("Total Attempts 5xx Array:", totalAttempts5xx);
      console.log("Total Attempts 6xx Array:", totalAttempts6xx);

      // Helper function to check if all values in an array are integers
      const isAllIntegers = (arr) => {
        return arr.every((val) => Number.isInteger(parseFloat(val)));
      };

      // Helper function to format total based on data type
      const formatTotal = (arr) => {
        const sum = arr.reduce((a, b) => a + b, 0);
        return isAllIntegers(arr) ? parseInt(sum) : sum.toFixed(2);
      };

      const revenueSum = totalRevenue.reduce((a, b) => a + b, 0);
      const costSum = totalCost.reduce((a, b) => a + b, 0);
      const profitSum = totalProfit.reduce((a, b) => a + b, 0);
      const minutesSum = totalMinutes.reduce((a, b) => a + b, 0);
      const acdSum = totalACD.reduce((a, b) => a + b, 0);
      const sdpSum = totalSDP.reduce((a, b) => a + b, 0);
      const asrSum = totalASR.reduce((a, b) => a + b, 0);
      const completedSum = totalCompleted.reduce((a, b) => a + b, 0);
      const inCallsSum = totalInCalls.reduce((a, b) => a + b, 0);
      const outCallsSum = totalOutCalls.reduce((a, b) => a + b, 0);
      const indeterminateMinutesSum = totalIndeterminateMinutes.reduce(
        (a, b) => a + b,
        0
      );
      const intraMinutesSum = totalIntraMinutes.reduce((a, b) => a + b, 0);
      const interMinutesSum = totalInterMinutes.reduce((a, b) => a + b, 0);
      const attempts404Sum = totalAttempts404.reduce((a, b) => a + b, 0);
      const attempts487Sum = totalAttempts487.reduce((a, b) => a + b, 0);
      const attempts4xxSum = totalAttempts4xx.reduce((a, b) => a + b, 0);
      const attempts503Sum = totalAttempts503.reduce((a, b) => a + b, 0);
      const attempts5xxSum = totalAttempts5xx.reduce((a, b) => a + b, 0);
      const attempts6xxSum = totalAttempts6xx.reduce((a, b) => a + b, 0);
      const sdCountSum = totalSDCount.reduce((a, b) => a + b, 0);

      // Log the total sums for each metric
      console.log("=== Total Sums ===");
      console.log("Total Revenue Sum:", revenueSum);
      console.log("Total Cost Sum:", costSum);
      console.log("Total Profit Sum:", profitSum);
      console.log("Total Minutes Sum:", minutesSum);
      console.log("Total ACD Sum:", acdSum);
      console.log("Total SDP Sum:", sdpSum);
      console.log("Total ASR Sum:", asrSum);
      console.log("Total Completed Sum:", completedSum);
      console.log("Total In Calls Sum:", inCallsSum);
      console.log("Total Out Calls Sum:", outCallsSum);
      console.log("Total Indeterminate Minutes Sum:", indeterminateMinutesSum);
      console.log("Total Intra Minutes Sum:", intraMinutesSum);
      console.log("Total Inter Minutes Sum:", interMinutesSum);
      console.log("Total Attempts 404 Sum:", attempts404Sum);
      console.log("Total Attempts 487 Sum:", attempts487Sum);
      console.log("Total Attempts 4xx Sum:", attempts4xxSum);
      console.log("Total Attempts 503 Sum:", attempts503Sum);
      console.log("Total Attempts 5xx Sum:", attempts5xxSum);
      console.log("Total Attempts 6xx Sum:", attempts6xxSum);
      console.log("Total SD Count Sum:", sdCountSum);

      // Helper function to calculate average for a column
      const calculateAverage = (arr) => {
        if (!arr.length) return 0;
        // Filter out non-numeric and N/A values
        const filtered = arr.map(v => (v === "N/A" ? 0 : parseFloat(v) || 0));
        const sum = filtered.reduce((a, b) => a + b, 0);
        return (sum / arr.length).toFixed(2);
      };

      return (
        <>
          <tr className="left_align" style={{ backgroundColor: "rgb(217 217 217 / 86%)", color: "black" }}>
            <td className="table-data"></td>
            <td className="table-data">
              <span style={{ fontWeight: "bold" }}>Total</span>
            </td>
            <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
              {fmtDollar4(isAllIntegers(totalRevenue)
                ? parseInt(revenueSum)
                : revenueSum.toFixed(2))}
            </td>
            <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
              {fmtDollar4(isAllIntegers(totalCost) ? parseInt(costSum) : costSum.toFixed(2))}
            </td>
            <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
              {fmtDollar4(isAllIntegers(totalProfit)
                ? parseInt(profitSum)
                : profitSum.toFixed(2))}
            </td>
            <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
              {fmtMins(isAllIntegers(totalMinutes)
                ? parseInt(minutesSum)
                : minutesSum.toFixed(2))}
            </td>
            <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
              {` ${this.calculateAverage(totalACD)}%`}
            </td>
            <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
              {` ${this.calculateAverage(totalSDP)}%`}
            </td>
            <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
              {` ${this.calculateAverage(totalASR)}%`}
            </td>
            <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
              {fmtInt(isAllIntegers(totalCompleted)
                ? parseInt(completedSum)
                : completedSum.toFixed(2))}
            </td>
            <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
              {fmtInt(isAllIntegers(totalInCalls)
                ? parseInt(inCallsSum)
                : inCallsSum.toFixed(2))}
            </td>
            <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
              {fmtInt(isAllIntegers(totalOutCalls)
                ? parseInt(outCallsSum)
                : outCallsSum.toFixed(2))}
            </td>
            <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
              {fmtMins(isAllIntegers(totalIndeterminateMinutes)
                ? parseInt(indeterminateMinutesSum)
                : indeterminateMinutesSum.toFixed(2))}
            </td>
            <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
              {fmtMins(isAllIntegers(totalIntraMinutes)
                ? parseInt(intraMinutesSum)
                : intraMinutesSum.toFixed(2))}
            </td>
            <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
              {fmtMins(isAllIntegers(totalInterMinutes)
                ? parseInt(interMinutesSum)
                : interMinutesSum.toFixed(2))}
            </td>
            <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
              {fmtInt(isAllIntegers(totalSDCount)
                ? parseInt(sdCountSum)
                : sdCountSum.toFixed(2))}
            </td>
            <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
              {` ${this.calculateAverage(totalAttempts404)}%`}
            </td>
            <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
              {` ${this.calculateAverage(totalAttempts487)}%`}
            </td>
            <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
              {` ${this.calculateAverage(totalAttempts4xx)}%`}
            </td>
            <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
              {` ${this.calculateAverage(totalAttempts503)}%`}
            </td>
            <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
              {` ${this.calculateAverage(totalAttempts5xx)}%`}
            </td>
            <td className="table-data" style={{ fontWeight: "bold", textAlign: "right" }}>
              {` ${this.calculateAverage(totalAttempts6xx)}%`}
            </td>
          </tr>
        </>
      );
    }
  }

  // Helper function to calculate average for a column
  calculateAverage(arr) {
    if (!arr.length) return 0;
    // Filter out non-numeric and N/A values
    const filtered = arr.map(v => (v === "N/A" ? 0 : parseFloat(v) || 0));
    const sum = filtered.reduce((a, b) => a + b, 0);
    return (sum / arr.length).toFixed(2);
  }

  render() {
    const {
      startDate,
      endDate,
      isGetting,
      data,
      isBtnSpin,
      isDownLoadSpin,
      excludeNoActivity,
    } = this.state;
    if (this.state.isLoginURL === true) {
      return <Redirect to={LOGIN_URL}></Redirect>;
    }
    return (
      <div className="">
        <div className="card-header header-elements-inline p-0 py-1 mb-1">
          <h5
            style={{ fontWeight: "700", fontSize: "24px" }}
            className="card-title"
          ></h5>
          <div className="header-elements"></div>
        </div>
        <div class="bg-light rounded border p-0 mb-2">
          <div style={{display:'flex',flexWrap:'wrap',gap:'6px',padding:'12px 16px 0 16px'}}>
            {[
              { key: "today", label: "Today" },
              { key: "yesterday", label: "Yesterday" },
              { key: "thisWeek", label: "This Week" },
              { key: "thisMonth", label: "This Month" },
            ].map((item) => (
              <button
                key={item.key}
                type="button"
                onClick={() => this.handleQuickDateSelect(item.key)}
                style={{
                  background: this.state.quickDatePreset === item.key ? "#4caf50" : "#fff",
                  color: this.state.quickDatePreset === item.key ? "#fff" : "#475569",
                  border: this.state.quickDatePreset === item.key ? "1px solid #4caf50" : "1px solid #dee2e6",
                  borderRadius: "6px",
                  padding: "4px 14px",
                  fontSize: "12px",
                  fontWeight: "500",
                  cursor: "pointer",
                }}
              >
                {item.label}
              </button>
            ))}
          </div>
          <div class="d-flex justify-content-between flex-wrap p-0">
          <div class=" py-2 px-3 mb-1">
            <div class="">
              <label
                style={{ fontWeight: "400", fontSize: "16px" }}
                className="fs-14"
              >
                Start Date
                <span className="fs-11 text-muted "> UTC Time-zone</span>{" "}
              </label>
              <div class="input-group">
                <DateRangePicker
                  key={"start-" + moment(startDate).valueOf()}
                  showWeekNumbers
                  onCallback={(date) => this.handleDate(date, "start")}
                  initialSettings={{
                    singleDatePicker: true,
                    showDropdowns: true,
                    startDate: moment(startDate),
                    locale: {
                      format: "MMMM/DD/YYYY",
                    },
                  }}
                >
                  <input
                    type="text"
                    className="form-control"
                    style={{ minWidth: "300px" }}
                  />
                </DateRangePicker>
              </div>
            </div>
          </div>
          <div class=" py-2 px-3 mb-1">
            <div class="">
              <label
                style={{ fontWeight: "400", fontSize: "16px" }}
                className="fs-14"
              >
                End Date<span className="text-muted "> UTC Time-zone</span>{" "}
              </label>
              <div class="input-group">
                <DateRangePicker
                  key={"end-" + moment(endDate).valueOf()}
                  onCallback={(date) => this.handleDate(date, "end")}
                  initialSettings={{
                    singleDatePicker: true,
                    showDropdowns: true,
                    startDate: moment(endDate),
                    locale: {
                      format: "MMMM/DD/YYYY",
                    },
                  }}
                >
                  <input
                    type="text"
                    className="form-control"
                    style={{ minWidth: "300px" }}
                  />
                </DateRangePicker>
              </div>
            </div>
          </div>
          <div class=" py-2 px-3 mb-1">
            <label style={{ fontWeight: "400", fontSize: "16px" }} className="">
              Filter Account
            </label>
            <div class=" w-20em">
              <MultiSelect
                options={this.state.accountList}
                selected={this.state.selectedAccount}
                onSelectedChanged={(selectedAccount) =>
                  this.setState({ selectedAccount })
                }
                overrideStrings={{
                  selectSomeItems: "Filter Account",
                  allItemsAreSelected: "All Account are Selected",
                  selectAll: "Select All Account",
                  search: "Search Account",
                }}
              />
            </div>
            <div
              className="custom-control custom-checkbox"
              style={{ marginLeft: 300, marginTop: -30 }}
            >
              <input
                type="checkbox"
                className="custom-control-input"
                id="excludeNoActivity"
                checked={excludeNoActivity}
                onChange={this.handleExcludeNoActivity}
              />
              <label
                className="custom-control-label"
                htmlFor="excludeNoActivity"
                style={{ fontSize: "14px" }}
              >
                Exclude ones with no activity
              </label>
            </div>
          </div>
          <div class="py-2 px-3 mb-1">
            <div
              className="d-flex flex-column align-items-start"
              style={{ marginTop: "2.5em" }}
            >
              <button
                style={{ fontWeight: "600" }}
                type="submit"
                className="btn main-button btn-success btn-sm border"
                onClick={this.getReportOnSelectDate}
              >
                Search{" "}
                <i
                  class={`${
                    isBtnSpin ? "icon-spinner4 spinner" : "icon-arrow-right8"
                  } ml-2`}
                ></i>
              </button>
            </div>
          </div>
          </div>
        </div>
        {/* row */}
        <div className="card-header header-elements-inline p-0 py-1 mb-2">
          <h5
            style={{ fontWeight: "700", fontSize: "24px" }}
            className="card-title"
          ></h5>
          <div className="header-elements">
            <button
              style={{ fontWeight: "600" }}
              type="submit"
              className="btn btn-success btn-sm main-button float-right "
              onClick={this.getReportOnSelectDate.bind(this, "download")}
            >
              Download CSV{" "}
              <i
                class={`${
                  isDownLoadSpin ? "icon-spinner4 spinner" : "icon-download7"
                } ml-2`}
              ></i>
            </button>
          </div>
        </div>
        <div className="">
          <div
            className="table-responsive"
            style={{ overflowX: "auto", overflowY: "auto", maxHeight: "56em" }}
          >
            <table className="table-style table table-striped  dataTable no-footer">
              <thead>
                <tr className="stickeyHeader table-heading-style">
                  <th></th>
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => this.handleSort("accountName")}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <span>Account</span>
                      {this.getSortIcon("accountName")}
                    </div>
                  </th>
                  <th
                    style={{ cursor: "pointer", textAlign: "right" }}
                    onClick={() => this.handleSort("revenue")}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        justifyContent: "flex-end",
                      }}
                    >
                      <span>Revenue</span>
                      {this.getSortIcon("revenue")}
                    </div>
                  </th>
                  <th
                    style={{ cursor: "pointer", textAlign: "right" }}
                    onClick={() => this.handleSort("cost")}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        justifyContent: "flex-end",
                      }}
                    >
                      <span>Cost</span>
                      {this.getSortIcon("cost")}
                    </div>
                  </th>
                  <th
                    style={{ cursor: "pointer", textAlign: "right" }}
                    onClick={() => this.handleSort("profit")}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        justifyContent: "flex-end",
                      }}
                    >
                      <span>Profit</span>
                      {this.getSortIcon("profit")}
                    </div>
                  </th>
                  <th
                    style={{ cursor: "pointer", textAlign: "right" }}
                    onClick={() => this.handleSort("minutes")}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        justifyContent: "flex-end",
                      }}
                    >
                      <span>Minutes</span>
                      {this.getSortIcon("minutes")}
                    </div>
                  </th>
                  <th
                    style={{ cursor: "pointer", textAlign: "right" }}
                    onClick={() => this.handleSort("ACD")}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        justifyContent: "flex-end",
                      }}
                    >
                      <span>ACD</span>
                      {this.getSortIcon("ACD")}
                    </div>
                  </th>
                  <th
                    style={{ cursor: "pointer", textAlign: "right" }}
                    onClick={() => this.handleSort("SDP")}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        justifyContent: "flex-end",
                      }}
                    >
                      <span>SDP</span>
                      {this.getSortIcon("SDP")}
                    </div>
                  </th>
                  <th
                    style={{ cursor: "pointer", textAlign: "right" }}
                    onClick={() => this.handleSort("ASR")}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        justifyContent: "flex-end",
                      }}
                    >
                      <span>ASR</span>
                      {this.getSortIcon("ASR")}
                    </div>
                  </th>
                  <th
                    style={{ cursor: "pointer", textAlign: "right" }}
                    onClick={() => this.handleSort("completed")}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        justifyContent: "flex-end",
                      }}
                    >
                      <span>Completed</span>
                      {this.getSortIcon("completed")}
                    </div>
                  </th>
                  <th
                    style={{ cursor: "pointer", textAlign: "right" }}
                    onClick={() => this.handleSort("inCalls")}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        justifyContent: "flex-end",
                      }}
                    >
                      <span>In Calls</span>
                      {this.getSortIcon("inCalls")}
                    </div>
                  </th>
                  <th
                    style={{ cursor: "pointer", textAlign: "right" }}
                    onClick={() => this.handleSort("outCalls")}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        justifyContent: "flex-end",
                      }}
                    >
                      <span>Out Calls</span>
                      {this.getSortIcon("outCalls")}
                    </div>
                  </th>

                  <th
                    style={{ cursor: "pointer", textAlign: "right" }}
                    onClick={() => this.handleSort("indeterminateMinutes")}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        justifyContent: "flex-end",
                      }}
                    >
                      <span>Indeterminate Minutes</span>
                      {this.getSortIcon("indeterminateMinutes")}
                    </div>
                  </th>
                  <th
                    style={{ cursor: "pointer", textAlign: "right" }}
                    onClick={() => this.handleSort("intrastateMinutes")}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        justifyContent: "flex-end",
                      }}
                    >
                      <span>Intra Minutes</span>
                      {this.getSortIcon("intrastateMinutes")}
                    </div>
                  </th>
                  <th
                    style={{ cursor: "pointer", textAlign: "right" }}
                    onClick={() => this.handleSort("interstateMinutes")}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        justifyContent: "flex-end",
                      }}
                    >
                      <span>Inter Minutes</span>
                      {this.getSortIcon("interstateMinutes")}
                    </div>
                  </th>
                  <th style={{ textAlign: "right" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        justifyContent: "flex-end",
                      }}
                    >
                      <span>SD Count</span>
                    </div>
                  </th>
                  <th
                    style={{ cursor: "pointer", textAlign: "right" }}
                    onClick={() => this.handleSort("attempts_404")}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        justifyContent: "flex-end",
                      }}
                    >
                      <span>404</span>
                      {this.getSortIcon("attempts_404")}
                    </div>
                  </th>
                  <th
                    style={{ cursor: "pointer", textAlign: "right" }}
                    onClick={() => this.handleSort("attempts_487")}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        justifyContent: "flex-end",
                      }}
                    >
                      <span>487</span>
                      {this.getSortIcon("attempts_487")}
                    </div>
                  </th>
                  <th
                    style={{ cursor: "pointer", textAlign: "right" }}
                    onClick={() => this.handleSort("attempts_4xx")}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        justifyContent: "flex-end",
                      }}
                    >
                      <span>4XX</span>
                      {this.getSortIcon("attempts_4xx")}
                    </div>
                  </th>
                  <th
                    style={{ cursor: "pointer", textAlign: "right" }}
                    onClick={() => this.handleSort("attempts_503")}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        justifyContent: "flex-end",
                      }}
                    >
                      <span>503</span>
                      {this.getSortIcon("attempts_503")}
                    </div>
                  </th>
                  <th
                    style={{ cursor: "pointer", textAlign: "right" }}
                    onClick={() => this.handleSort("attempts_5xx")}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        justifyContent: "flex-end",
                      }}
                    >
                      <span>5XX</span>
                      {this.getSortIcon("attempts_5xx")}
                    </div>
                  </th>
                  <th
                    style={{ cursor: "pointer", textAlign: "right" }}
                    onClick={() => this.handleSort("attempts_6xx")}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                        justifyContent: "flex-end",
                      }}
                    >
                      <span>6XX</span>
                      {this.getSortIcon("attempts_6xx")}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {isGetting ? <CustomLoader /> : this.renderReportTable()}
                {data.length > 0 ? this.returnTotal() : ""}
              </tbody>
            </table>
          </div>
        </div>
        <ReactTooltip
          type="success"
          backgroundColor="#4caf50"
          place="top"
          effect="solid"
        />
      </div>
    );
  }
}
export default withRouter(ChangeAccountStats);
